import logo from './logo.svg';
import './App.css';
import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Header from './components/common/Header';
import OtherItems from './components/common/OtherItems';
import RequireAuth from './components/RequireAuth';
import ComingSoon from './components/ComingSoon';
import Home from './components/Home';
import Login from './components/Login';
import KnowledgeCenter from './components/KnowledgeCenter';
import ErrorPage from './components/ErrorPage';
import Cookie from './components/common/Cookie';
import Sessions from './components/Sessions';
import TopicAdd from './components/topic/TopicAdd';
import TopicList from './components/topic/TopicList';
import TopicDetail from './components/topic/TopicDetail';
import MyAccount from './components/MyAccount';
import PaginationComponent from './components/Pagination';

//import EditorCheck from './EditorCheck';

function App() {

  return (
    <div className="App">

        <Router>
          {/*******set cookie on loing page*********/}
          <Cookie />

          {/***********Header run single time when load the page, it will not run on routing of pages*************/}
          <Header /> 
          
          <OtherItems />
                            
          <Routes>

              <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
              <Route path="/knowledge-center/" element={<RequireAuth><KnowledgeCenter /></RequireAuth>} />
              {/* <Route path="/home-live" element={<RequireAuth><Home /></RequireAuth>} /> */}

              <Route path="/sessions/" element={<RequireAuth><Sessions /></RequireAuth>} />
              <Route path="/sessions/:year/:id" element={<RequireAuth><Home /></RequireAuth>} />

              <Route path="/my-account" element={<RequireAuth><MyAccount /></RequireAuth>} />

              <Route path="/topic-add" element={<RequireAuth><TopicAdd /></RequireAuth>} />
              <Route path="/topic-list" element={<RequireAuth><TopicList /></RequireAuth>} />
              <Route path="/topic/:id" element={<RequireAuth><TopicDetail /></RequireAuth>} />

              <Route path="/pagination" element={<RequireAuth><PaginationComponent /></RequireAuth>} />

              {/* <Route path="/editorcheck" element={<EditorCheck />} /> */}

              
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<ErrorPage />} />

          </Routes>



      </Router>
    </div>
  );
}

export default App;
